import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import onClickOutside from 'react-onclickoutside';
import Navigation from './navigation/navigation';

class Sidebar extends Component {
  getChildContext() {
    return {
      collapsed: this.props.collapsed && !this.context.sidebarActive,
    };
  }

  collapseExpandSidebar = () => {
    this.props.setCollapsed(!this.props.collapsed);
  };

  handleClickOutside = (callback) => {
    if (callback && typeof callback === 'function') {
      callback();
    }

    this.context.toggleSidebar(false);
  };

  render() {
    const { navData, collapsed } = this.props;
    const sidebarClass = classNames(
      'c-user-sidebar',
      { 'is-active': this.context.sidebarActive },
      { 'is-collapsed': collapsed }
    );

    return (
      <aside
        className={sidebarClass}
        data-target-id="sidebar"
      >
        <Navigation
          navData={navData}
          collapseExpand={this.collapseExpandSidebar}
          onItemClick={this.handleClickOutside}
        >
          {this.props.children}
        </Navigation>
      </aside>
    );
  }
}

Sidebar.propTypes = {
  navData: PropTypes.array.isRequired,
  children: PropTypes.node,
  collapsed: PropTypes.bool.isRequired,
  setCollapsed: PropTypes.func.isRequired,
};
Sidebar.defaultProps = {
  children: null,
};
Sidebar.contextTypes = {
  sidebarActive: PropTypes.bool.isRequired,
  toggleSidebar: PropTypes.func.isRequired,
};
Sidebar.childContextTypes = {
  collapsed: PropTypes.bool,
};

export default onClickOutside(Sidebar);
